import { render, staticRenderFns } from "./OldDashBoard.vue?vue&type=template&id=06e83a7a&"
import script from "./OldDashBoard.vue?vue&type=script&lang=js&"
export * from "./OldDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./OldDashBoard.vue?vue&type=style&index=0&id=06e83a7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports